import { render, staticRenderFns } from "./ResourceSearchResults.vue?vue&type=template&id=609ba5fe"
import script from "./ResourceSearchResults.ts?vue&type=script&lang=ts&external"
export * from "./ResourceSearchResults.ts?vue&type=script&lang=ts&external"
import style0 from "./ResourceSearchResults.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports